import React from 'react'

import { getTestParam } from '@js/common/utils'

import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'

import FilterFeature from './FilterFeature'
import FilterCheckbox from './types/FilterCheckbox'
import FilterRadio from './types/FilterRadio'
import FilterSelect from './types/FilterSelect'
import FilterSlider from './types/FilterSlider'
const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

const FilterWrapper = props => {
  const filterProps = { ...props }
  const currentFilters = getFilters(props.filtersList, filterProps)

  return currentFilters.map(currentFilter => (
    <div
      className='[ f-m-b-020 f-c-bo-neu025 ] SearchResultsFilterWrapper'
      key={`filter_wrapper_${currentFilter.name}`}>
      <span className='[ f-d-bl f-t-body f-t-bold f-c-fo-pri f-p-b-020 ]'>
        {currentFilter.label}
      </span>

      {currentFilter.feature && (
        <FilterFeature feature={currentFilter.feature} />
      )}
      {currentFilter.filterComponent}
      {currentFilter.info ? (
        <div className='[ f-p-t-020 f-t-body f-c-fo-pri ]'>
          {currentFilter.info}
        </div>
      ) : null}
    </div>
  ))
}

const getFilters = (filters, filterProps) => {
  if (filters.length < 1) {
    return []
  }

  return filters.map(filter => {
    const props = {
      filter,
      ...filterProps
    }

    switch (filter.type) {
      case 'price':
        var isPrice = true
        filter.values.slots = { ...props.slots }

      case 'range':
        return {
          ...filter,
          filterComponent: <FilterSlider {...props} isPrice={isPrice} />
        }

      case 'radio':
        filter['currentValue'] = filter.default

        filter.values.map(el => {
          if (
            (props.filters &&
              Object.hasOwn(props.filters, `${el.id}__range`)) ||
            (props.filters && Object.hasOwn(props.filters, `${el.id}__in`))
          ) {
            filter['currentValue'] = el.id
          }
        })

        return {
          ...filter,
          filterComponent: filter.values.map(el => {
            return (
              <FilterRadio
                key={`filter_radio_${filter.name}`}
                option={el}
                {...props}
              />
            )
          })
        }

      case 'checkbox':
        return {
          ...filter,
          filterComponent: filter.values.map(el => {
            return (
              <FilterCheckbox
                key={`filter_checkbox_${filter.name}`}
                option={el}
                {...props}
              />
            )
          })
        }

      case 'vendor-direct':
        var isVendorDirect = true

      case 'select':
        return {
          ...filter,
          filterComponent: (
            <FilterSelect {...props} isVendorDirect={isVendorDirect} />
          )
        }

      case 'bauort':
        return {
          ...filter,
          filterComponent: (
            <>
              <span className='[ f-d-bl f-t-body f-c-fo-pri f-m-b-010 ]'>
                In einem Umkreis von 50 km, PLZ/Ort:
              </span>
              <LocationFinder
                wtLocation='search_results_filter_location_finder'
                className='[ f-d-bl ]'
                inputClassName='[ f-c-bo-neu025 ] has-border'
              />
            </>
          )
        }

      default:
        return {
          ...filter,
          filterComponent: null
        }
    }
  })
}

export default FilterWrapper
